import type { ReactNode } from 'react';

import {
  ClockCircleOutlined,
  DesktopOutlined,
  EnvironmentOutlined,
  LaptopOutlined,
  MailOutlined,
  PhoneOutlined,
  ReadOutlined,
  SolutionOutlined,
} from '@ant-design/icons';

import type { ICurrentAdmissionApplication } from '@/api/endpoints/schools/schoolSelectionPanel';
import { EDUCATION_LEVEL_TO_TEXT_MAPPER, STUDY_FORM_TO_TEXT_MAPPER, STUDY_YEAR_TO_TEXT_MAPPER } from '@/shared/consts';

export const formatPhone = (phone: string) =>
  `${phone.slice(0, 2)} (${phone.slice(2, 5)}) ${phone.slice(5, 8)}-${phone.slice(8, 10)}-${phone.slice(10, 12)}`;

export const formatCandidateApplicationSurveyData = ({
  user: { email, phone },
  city,
  university,
  specialization,
  education_level: educationLevel,
  study_form: studyForm,
  study_year: studyYear,
  motivation,
  available_time: availableTime,
  has_computer: hasComputer,
  currently_working: currentlyWorking,
  work_place: workPlace,
}: Omit<ICurrentAdmissionApplication, 'created_at'>): {
  id: number;
  title: string;
  dataValue: string;
  icon: ReactNode;
  theme?: 'primary' | 'secondary';
}[] => [
  {
    id: 1,
    title: 'Email',
    dataValue: email,
    icon: <MailOutlined />,
  },
  {
    id: 2,
    title: 'Телефон',
    dataValue: phone ? formatPhone(phone) : '-',
    icon: <PhoneOutlined rotate={90} />,
  },
  {
    id: 3,
    title: 'Город проживания',
    dataValue: city,
    icon: <EnvironmentOutlined />,
    theme: 'secondary',
  },
  {
    id: 4,
    title: 'Название учебного заведения',
    dataValue: university,
    icon: <ReadOutlined />,
    theme: 'secondary',
  },
  {
    id: 5,
    title: 'Специализация',
    dataValue: specialization,
    icon: <ReadOutlined />,
    theme: 'secondary',
  },
  {
    id: 6,
    title: 'На программе какого уровня Вы учитесь?',
    dataValue: EDUCATION_LEVEL_TO_TEXT_MAPPER[educationLevel],
    icon: <ReadOutlined />,
    theme: 'secondary',
  },
  {
    id: 7,
    title: 'Форма обучения',
    dataValue: STUDY_FORM_TO_TEXT_MAPPER[studyForm],
    icon: <ReadOutlined />,
    theme: 'secondary',
  },
  {
    id: 8,
    title: 'На каком курсе Вы сейчас учитесь?',
    dataValue: STUDY_YEAR_TO_TEXT_MAPPER[studyYear],
    icon: <ReadOutlined />,
    theme: 'secondary',
  },
  {
    id: 9,
    title: 'В случае успешного обучения в Школе, Вы хотели бы перейти работать в ИТ ПСБ? Если да — почему?',
    dataValue: motivation,
    icon: <LaptopOutlined />,
    theme: 'secondary',
  },
  {
    id: 10,
    title: 'У Вас есть возможность обучаться в нерабочее/неучебное время, включая выходные дни (6–10 часов в неделю)?',
    dataValue: availableTime,
    icon: <ClockCircleOutlined />,
    theme: 'secondary',
  },
  {
    id: 11,
    title:
      'У Вас есть возможность проходить обучение на личном компьютере (Windows, Mac, Linux) с использованием Zoom, Телемост и т.д.?',
    dataValue: hasComputer ? 'Да' : 'Нет',
    icon: <DesktopOutlined />,
    theme: 'secondary',
  },
  {
    id: 12,
    title: 'Работаете ли Вы сейчас? Если да — напишите, пожалуйста, где',
    dataValue: currentlyWorking ? `Да. ${workPlace}` : 'Нет',
    icon: <SolutionOutlined />,
    theme: 'secondary',
  },
];
